import styled from 'styled-components';

export const HeadingContainer = styled.div`
  margin-bottom: 30px;
`;
